import { create } from 'zustand';

export type ModalType = 'subscription' | 'recording' | 'video';

interface ModalStore {
  type: ModalType | null;
  data: any;
  isOpen: boolean;
  onOpen: (type: ModalType, data?: any) => void;
  onClose: () => void;
}

export const useModal = create<ModalStore>()((set, get) => ({
  type: null,
  data: {},
  isOpen: false,
  onOpen: (type, data = {}) => {
    console.log('Modal onOpen called', { type, data });
    set({ isOpen: true, type, data });
  },
  onClose: () => {
    const currentState = get();

    // Only log on client side
    if (typeof window !== 'undefined') {
      console.log('Modal closing - current state:', currentState);
    }

    set({ type: null, data: {}, isOpen: false });

    // Only log on client side
    if (typeof window !== 'undefined') {
      console.log('Modal closing - new state:', get());
    }
  },
}));
